mainApp.component('contactSupport',{
    templateUrl: '/public/components/contact-support.component.html',
    bindings: {
        contactSupportPolicy: '=',
        isSystem: '=',
        changesListener: '&',
    },
    controller: contactSupportController
});

function contactSupportController($scope, $state){
    var $ctrl = this;

    $ctrl.$onInit = function() {
       reload();
    }

    $ctrl.$doCheck = function() {
        if (!$ctrl.changesListener)
            return;

        var isChangedNow = !angular.equals($ctrl.contactSupportPolicy, $ctrl.original);

    //check if listener was already called and updates about having changes
        if ($ctrl.hasChanges === isChangedNow)
            return;

        $ctrl.hasChanges = isChangedNow;
        $ctrl.changesListener({isDirty: $ctrl.hasChanges, componentName: 'contactSupport'});
    }

     //the model was changed and settings need to be reloaded
     $scope.$on('modelReloadedEvent', function (event, data) {
       reload();
    });

    $scope.$watch('$ctrl.contactSupportPolicy.directToCato', function(after, before) {
        if (after) {
            if(!$ctrl.contactSupportPolicy.directToCatoExpiration) {
                $ctrl.contactSupportPolicy.directToCatoExpiration = new Date().getTime();
            }
        }
    });

    //checks that entered message has up to 5 lines with up to 50 characters each
    $ctrl.checkTextValidity = function() {

    if($ctrl.contactSupportPolicy.message){
        var lines = $ctrl.contactSupportPolicy.message.split('\n');

        //check number of lines
        $ctrl.invalidMessage = lines.length > 5;

        //if message has valid number of lines, check each line's length
        if(!$ctrl.invalidMessage){
            lines.forEach(function(line){
                       $ctrl.invalidMessage = $ctrl.invalidMessage || line.length > 50;
                    });
        }
    }

    }

    //set default contact support message for user to edit - only if user selected "show contact support" and hasnt set a message yet
    $ctrl.setDefaultMessageIfNeeded = function(){
        if(!$ctrl.contactSupportPolicy.message && $ctrl.contactSupportPolicy.showContactSupport){
                $ctrl.contactSupportPolicy.message = 'Our support contact details are:\nUS: +1-000-000-000\nEU: +44-000-000-000 \nAPJ: +81-000-000-000 \nor email support@myorg.com';
             }
    }

    function reload() {
     $ctrl.original = angular.copy($ctrl.contactSupportPolicy);
    }

}